import { IconType } from 'react-icons'
import {
    LuArrowLeftRight,
    LuBanknote,
    LuCalendarClock,
    LuCoins,
    LuGift,
    LuLandmark,
    LuMegaphone,
    LuMessagesSquare,
} from 'react-icons/lu'

export interface CategoryMeta {
    /** Chip label, and the caption on a card next to the time. */
    label: string
    /** The card's title when the message is not about one of our funds. */
    title: string
    Icon: IconType
    /** Icon tile on a card. */
    tile: string
    /** A selected filter chip. */
    chip: string
}

/**
 * What each `category` (backend: `peripheral/message_categories.py`) looks
 * like. The order is the order of the filter chips: what a member most often
 * looks for first.
 */
export const CATEGORY_META: Record<TInboxCategory, CategoryMeta> = {
    installment: {
        label: 'قسط',
        title: 'یادآوری قسط',
        Icon: LuCalendarClock,
        tile: 'bg-warning-soft text-warning-on',
        chip: 'border-warning-1 bg-warning-soft text-warning-on',
    },
    membership: {
        label: 'حق عضویت',
        title: 'حق عضویت',
        Icon: LuCoins,
        tile: 'bg-brand-soft text-brand-deep',
        chip: 'border-green-1 bg-brand-soft text-brand-deep',
    },
    loan: {
        label: 'وام',
        title: 'وام',
        Icon: LuBanknote,
        tile: 'bg-blue-6 text-blue-1',
        chip: 'border-blue-1 bg-blue-6 text-blue-1',
    },
    loan_chat: {
        label: 'گفت‌وگوی وام',
        title: 'گفت‌وگوی وام',
        Icon: LuMessagesSquare,
        tile: 'bg-blue-6 text-blue-4',
        chip: 'border-blue-4 bg-blue-6 text-blue-3',
    },
    transfer: {
        label: 'واریز و برداشت',
        title: 'واریز و برداشت',
        Icon: LuArrowLeftRight,
        tile: 'bg-success-2 text-success-on',
        chip: 'border-success-1 bg-success-2 text-success-on',
    },
    lottery: {
        label: 'قرعه‌کشی',
        title: 'قرعه‌کشی',
        Icon: LuGift,
        tile: 'bg-[#F3EEFF] text-[#6E4FD8]',
        chip: 'border-[#9B84F0] bg-[#F3EEFF] text-[#6E4FD8]',
    },
    hamyan: {
        label: 'همیان',
        title: 'پیام همیان',
        Icon: LuMegaphone,
        tile: 'bg-green-1 text-white',
        chip: 'border-green-1 bg-green-1 text-white',
    },
    fund: {
        label: 'صندوق',
        title: 'اطلاعیهٔ صندوق',
        Icon: LuLandmark,
        tile: 'bg-divider text-gray-1',
        chip: 'border-gray-1 bg-divider text-heading',
    },
}

export const CATEGORY_ORDER = Object.keys(CATEGORY_META) as TInboxCategory[]

export const isInboxCategory = (value: unknown): value is TInboxCategory =>
    typeof value === 'string' && value in CATEGORY_META

export const PERIODS: { key: TInboxPeriod | 'all'; label: string }[] = [
    { key: 'all', label: 'همه' },
    { key: 'day', label: 'یک روز' },
    { key: 'week', label: 'یک هفته' },
    { key: 'month', label: 'یک ماه' },
]

export const isInboxPeriod = (value: unknown): value is TInboxPeriod =>
    value === 'day' || value === 'week' || value === 'month'

/** «در ۲۴ ساعت گذشته» — the tail of the result line under the filters. */
export const PERIOD_PHRASE: Record<TInboxPeriod, string> = {
    day: 'در ۲۴ ساعت گذشته',
    week: 'در هفتهٔ گذشته',
    month: 'در ماه گذشته',
}
